import React, { useEffect } from "react";

import { useIsSSR } from "react-aria";

import styled from "@emotion/styled";

import { SearchInputWithGoogleMapsScript } from "../../../shared/maps/SearchInput";
import { germany } from "../../GasStations/hardCodedMapSearchBounds";
import RangeSlider from "./RangeSlider";
import useStore from "./store";

const SearchWrapper = styled.div`
    position: relative;
    width: 100%;
    flex-grow: 1;
    ${({ theme }) => theme.breakpoints.from.small.css`
       width: 300px;
    `}
`;

const RangeWrapper = styled.div`
    width: 100%;
    ${({ theme }) => theme.breakpoints.from.small.css`
       width: 200px;
    `}
`;

const ClearSearch = styled.button`
    all: unset;
    position: absolute;
    right: 5px;
    bottom: -9px;
    font-size: 34pt;
    color: ${({ theme }) => theme.colors.darkGrey.toString()};
    cursor: pointer;
`;

const ProximityFilter = () => {
    const isSSR = useIsSSR();
    const [proximityData, setProximityData, clearProximityData] = useStore(
        (state) => [
            state.proximityData,
            state.setProximityData,
            state.clearProximityData,
            state.hasProximityData,
        ]
    );

    //Try to set the proximity Data from the URL params
    useEffect(() => {
        if (!isSSR) return;
        const params = new URLSearchParams(window.location.search);
        if (params.has("lat") && params.has("long") && params.has("rangeKm")) {
            setProximityData({
                ...proximityData,
                lat: parseFloat(params.get("lat") ?? ""),
                long: parseFloat(params.get("long") ?? ""),
                rangeKm: parseInt(params.get("rangeKm") ?? ""),
                inputValue: params.get("address") ?? "",
            });
        }
    }, []);

    const handleLocationChange = (geoData: any[]): void => {
        setProximityData({
            ...proximityData,
            lat: geoData[0].geometry.location.lat(),
            long: geoData[0].geometry.location.lng(),
            inputValue: geoData[0].formatted_address,
        });
    };

    const handleRangeChange = (range: number): void => {
        setProximityData({ ...proximityData, rangeKm: range });
    };

    //If the user removes the input text: Clear the proximity data.
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
        if (!event.target.value) {
            clearProximityData();
        }
    };

    return (
        <>
            <SearchWrapper>
                <SearchInputWithGoogleMapsScript
                    bounds={germany}
                    withIcon={false}
                    placeholder="Postleitzahl oder Ort"
                    onPlacesChange={handleLocationChange}
                    onChange={handleChange}
                    defaultValue={proximityData.inputValue}
                />
                <ClearSearch onClick={clearProximityData}>&times;</ClearSearch>
            </SearchWrapper>

            {proximityData.inputValue && (
                <RangeWrapper>
                    <RangeSlider
                        unit="km"
                        title="Radius"
                        min={10}
                        max={150}
                        step={10}
                        value={proximityData.rangeKm}
                        onChange={handleRangeChange}
                    />
                </RangeWrapper>
            )}
        </>
    );
};

export default ProximityFilter;
